<template>
  <div>
    <modern-filter-bar
      embedded
      single-line
      inline-period
      :show-timeseries="false"
      :show-search="purpose == 'master'"
      :search-text.sync="filter.patient_name"
      :show-period="true"
      :start-date.sync="filter.start_date"
      :end-date.sync="filter.end_date"
      search-placeholder="Cari nama pasien"
      @search-keyup="filterByPatient"
      @period-search="filterByPeriode"
      @period-reset="resetFilterPeriode"
    >
      <template #before-search>
        <div v-if="currentUser.user_type_id != 1" class="modern-filter-select">
          <treeselect
            v-model="filter.doctor_id"
            :multiple="false"
            :options="doctors"
            placeholder="Semua dokter"
            @input="filterByDoctor"
          />
        </div>
      </template>
    </modern-filter-bar>

    <!-- Filter -->
    <medhop-data-table
      summary-title="Laporan Pemeriksaan Laboratorium"
      striped
      hover
      responsive
      style="white-space: nowrap"
      class="mt-3"
      :items="items"
      :fields="fields">
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{
            width:
              purpose == 'master'
                ? field.key === 'actions'
                  ? '25%'
                  : ''
                : field.key === 'actions'
                  ? '15%'
                  : '',
          }" />
      </template>
      <template #cell(actions)="data">
        <template v-if="purpose == 'master'">
          <b-button
            size="sm"
            class="mr-1 btn-warning"
            @click="
              $router.push({ path: '/lab-report-2/attachment/' + data.item.id })
            "><i class="far fa-file px-0"></i></b-button>
          <b-button
            size="sm"
            class="mr-1 btn-info"
            @click="
              $router.push({ path: '/lab-report-2/detail/' + data.item.id })
            "><i class="fas fa-eye px-0"></i></b-button>
          <b-button
            size="sm"
            class="mr-1 btn-success"
            v-if="manipulateBtn == true"
            @click="$router.push({ path: '/lab-report-2/edit/' + data.item.id })"><i class="fas fa-edit px-0"></i></b-button>
          <b-button
            size="sm"
            class="btn-danger"
            v-if="manipulateBtn == true"
            @click="btnDeleteOnClick(data.item.id)"><i class="fas fa-trash px-0"></i></b-button>
        </template>
        <template v-if="purpose === 'patient-history'">
          <b-button
            size="sm"
            class="mr-1 btn-success"
            v-b-modal.modal-print-lab
            @click="btnDetailOnClick(data.item.id)"><i class="fas fa-eye px-0"></i></b-button>
          <b-button
            size="sm"
            class="btn-info"
            v-b-modal.modal-print-lab
            @click="btnDownloadOnClick(data.item.id)"><i class="fas fa-download px-0"></i></b-button>
        </template>
      </template>
      <template #cell(workflow_status)="data">
        <b-badge :variant="statusVariant(data.item.workflow_status)">
          {{ data.item.workflow_status_label }}
        </b-badge>
        <b-badge v-if="data.item.has_critical_result" variant="danger" class="ml-1">Kritis</b-badge>
        <b-badge v-else-if="data.item.has_abnormal_result" variant="warning" class="ml-1">Abnormal</b-badge>
      </template>
    </medhop-data-table>
    <medhop-pagination
      v-if="items.length != 0"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      @page-click="pageOnClick"
      class="mt-4"></medhop-pagination>
  </div>
</template>

<script>

import Treeselect from "@riophae/vue-treeselect";
import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getUser } from "@/core/services/jwt.service.js";

export default {
  props: {
    items: Array,
    fields: Array,
    purpose: String,
    perPage: Number,
    currentPage: Number,
    totalRows: Number,
    hasPatient: Boolean,
  },

  components: {
    Treeselect,
  },

  data() {
    return {
      // Filter
      filter: {
        doctor_id: "",
        patient_name: "",
        start_date: "",
        end_date: "",
      },
      // Options
      doctors: [],
      manipulateBtn: false,
      // current user
      currentUser: getUser(),
    };
  },

  methods: {
    statusVariant(status) {
      return { draft: 'secondary', final: 'warning', verified: 'success', corrected: 'info', cancelled: 'danger' }[status] || 'secondary';
    },
    pageOnClick(page) {
      this.$emit("pageOnClick", page);
    },

    async getDoctorsOption() {
      let response = await module.setDoctorTreeSelect("doctors");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.doctors = response.data;
        this.doctors.unshift({
          label: "Filter Berdasar Dokter",
          id: "",
          isDisabled: true,
        });
      }
    },

    async filterByDoctor(evt) {
      await this.filter.doctor_id;
      this.$emit("filter", this.filter);
    },

    resetFilterPeriode() {
      this.filter.start_date = "";
      this.filter.end_date = "";
      this.filter.patient_name = "";
      if (this.currentUser.user_type_id != 1) {
        this.filter.doctor_id = "";
      }
      this.$emit("filter", this.filter);
    },

    filterByPeriode() {
      this.$emit("filter", this.filter);
    },

    async filterByPatient() {
      debouncer(() => {
        this.$emit("filterByPatient", this.filter);
      }, 500)
    },

    btnDeleteOnClick(id) {
      this.$emit("btnDeleteOnClick", id);
    },

    btnDownloadOnClick(id) {
      this.$emit("btnDownloadOnClick", id);
    },

    btnDetailOnClick(id) {
      this.$emit("btnDetailOnClick", id);
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        ;

        if (access_right[a] == "1102") {
          this.manipulateBtn = true;
        }
      }
    },
  },

  watch: {
    "filter.doctor_id": function (newVal, oldVal) {
      if (typeof newVal === "undefined") {
        this.filter.doctor_id = "";
        this.filterByDoctor();
      }
    },
  },

  mounted() {
    if (this.currentUser.user_type_id != 1) {
      // Get Options
      this.getDoctorsOption();
    }
    this.setActiveMenu();
  },
};
</script>

<style></style>
